// REACT
import React, { Component } from 'react';

// STYLING
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import IconButton from '../../../components/Button/IconButton';

// Utilities
const moment = require('moment');

const StyledExceptionDay = styled.div`
    color: white;
    text-align: center;
    background-color: #3fa9b4;
    font-size: 12px;
    border-radius: 15px;
    margin: 12px 8px;
    padding: 5px;
    box-shadow: -1px 1px 5px rgba(0, 0, 0, 0.2);
`;

const StyledExceptionDayComponent = ({date, showDeleteConfirmationDialog, showExceptionCard, deleteType}) => {
        let dateString = moment(date).format("dddd, MMMM Do YYYY");
        
        return (
            <StyledExceptionDay>
                <p>
                    {dateString}
                    {/* <IconButton onClick={(e) => {showExceptionCard(e, date)}} >
                        <FontAwesomeIcon 
                            icon={['far', 'pencil']}
                            style={{ opacity: 1 }}
                            size={"1x"}
                            color="#FFFFFF"
                        />
                    </IconButton> */}
                    <IconButton onClick={(e) => {showDeleteConfirmationDialog(e, date, deleteType)}}>
                        <FontAwesomeIcon 
                            icon={['far', 'trash-alt']}
                            style={{ opacity: 1 }}
                            size={"1x"}
                            color="white"
                        />
                    </IconButton>
                </p>
            </StyledExceptionDay>
        );
};

export default StyledExceptionDayComponent;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/components/StyledExceptionDayComponent.jsx